var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-content',[_c('h3',{staticClass:"tw-text-gray-700 tw-text-xl tw-font-normal"},[_vm._v("Not Authorized")]),_c('div',{staticClass:"tw-text-gray-700 tw-text-md tw-mt-2"},[_vm._v("You are not authorized to view this content.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }